import domtoimage from "dom-to-image";
import { PDFDocument } from "pdf-lib";

const arrayBufferToBase64 = (buffer) => {
  let binary = "";
  const bytes = new Uint8Array(buffer);
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

export const handleDownloadPdf = async (element) => {
  try {
    // Salva o estilo original do elemento
    const originalStyle = element.style.cssText;

    // Define um estilo temporário para capturar a imagem
    element.style.width = "1050px";
    element.style.height = "auto";
    element.style.transform = "scale(1)";

    // Captura a imagem do elemento
    const dataUrl = await domtoimage.toPng(element);

    // Restaura o estilo original
    element.style.cssText = originalStyle;

    // Cria um elemento Image e aguarda o carregamento
    const img = new Image();
    img.src = dataUrl;
    await new Promise((resolve, reject) => {
      img.onload = resolve;
      img.onerror = reject;
    });

    // Cria um novo documento PDF
    const pdfDoc = await PDFDocument.create();

    // Define dimensões A4 (em pontos)
    const a4Width = 595.28; // largura A4 em pontos
    const a4Height = 842.28; // altura A4 em pontos

    // Calcula o fator de escala da imagem para o PDF
    const scaleFactor = a4Width / img.width;
    // Em pixels, qual fatia corresponde a uma página A4 (altura):
    const sliceHeightOriginal = a4Height / scaleFactor;

    // Determina o número total de páginas necessárias
    const totalPages = Math.ceil(img.height / sliceHeightOriginal);

    // Para cada fatia, cria uma página no PDF
    for (let i = 0; i < totalPages; i++) {
      // Cria um canvas offscreen para obter a fatia da imagem
      const canvas = document.createElement("canvas");
      // Calcula a altura da fatia (última fatia pode ser menor)
      const currentSliceHeight = Math.min(
        sliceHeightOriginal,
        img.height - i * sliceHeightOriginal
      );
      canvas.width = img.width;
      canvas.height = currentSliceHeight;
      const ctx = canvas.getContext("2d");

      // Desenha a fatia correspondente da imagem no canvas
      ctx.drawImage(
        img,
        0, // origem x na imagem
        i * sliceHeightOriginal, // origem y na imagem
        img.width, // largura da fatia na imagem
        currentSliceHeight, // altura da fatia na imagem
        0, // destino x no canvas
        0, // destino y no canvas
        img.width, // largura desenhada
        currentSliceHeight // altura desenhada
      );

      // Converte o canvas para dataUrl
      const sliceDataUrl = canvas.toDataURL("image/png");
      // Calcula a altura da página no PDF (em pontos) para essa fatia
      const pdfPageHeight = currentSliceHeight * scaleFactor;

      // Adiciona uma nova página ao PDF com dimensões definidas
      const page = pdfDoc.addPage([a4Width, pdfPageHeight]);

      // Embebe a fatia como imagem no PDF
      const pdfImage = await pdfDoc.embedPng(sliceDataUrl);

      // Desenha a fatia na página
      page.drawImage(pdfImage, {
        x: 0,
        y: 0,
        width: a4Width,
        height: pdfPageHeight,
      });
    }

    // Salva o PDF em bytes
    const modifiedPdfBytes = await pdfDoc.save();

    // Converte para base64 para download ou envio
    const base64Pdf = arrayBufferToBase64(modifiedPdfBytes);

    return base64Pdf;
  } catch (error) {
    console.error("Erro ao gerar o PDF:", error);
  }
};
